import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6kmecnrnv: FaireProductEntity = {
  token: "p_y6kmecnrnv",
  type: "product",
  name: "Lavender Mint Organic Herbal Tea Sachets",
  brandToken: "b_9jd96k047p",
  brandName: "Rishi Tea & Botanicals",
  imageUrl: "https://cdn.faire.com/fastly/0196a521763c08479dc9789e718571bd8797fe456a95d5bb4b87370311140e32.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/103e1a39ff7b49416a4feddf93b8957a5358ac36005aeb36e16910fabe309338.png",
    "https://cdn.faire.com/fastly/a82086fbf03d7914aa3511ecfbf3e85ffe17bfd2bc56cc01af5b742e58a4c3c6.jpeg",
    "https://cdn.faire.com/fastly/eda520ffb37842ceea829c3a59df50628d7cecef843ca38b480ebae954767c8e.jpeg",
    "https://cdn.faire.com/fastly/e23e7925148f5fdb8a8c63d243eab0ef402639d2c66cd4946b728eca4c14d5e2.jpeg"
  ],
  priceDollars: 10.39,
  description: "This item comes in a case of 6 retail-ready boxes of 15 sachets.\n\nLavender Mint is a rejuvenating blend featuring sweet peppermint, clarifying sage and calming lavender. A hint of licorice root enhances the soothing effect and elevates the refreshing spa aromatics of the herbs with its subtle sweetness. Lavender Mint is a cup of perfect tranquility.\n\nTASTING NOTES\nSoothing mint, sage and lavender in perfect harmony.\n\nCAFFEINE LEVEL\nNone",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:58.181Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
